import { ObjectUtil } from "../../../../../components/common/object-util/object-util";

/**
 * Paging data for the HCashFlow widget
 */
export class HCashFlowWidgetPageData {
  /**
   * Constructor
   * @param masterThis Master widget this context
   * @param originalData Original data
   */
  constructor(masterThis: any, originalData: any = null) {
    this.masterThis = masterThis;
    this.originalData = originalData === null ? null : ObjectUtil.deepCopy(originalData);
    this.widgetPages = masterThis ? masterThis.widgetPages : [];

    if (originalData) {
      const data = originalData;
      this.years = data.years;
      this.capitalisationRate = data.capitalisationRate;
      this.cashFlowSum = data.cashFlowSum;
      this.discountRate = data.discountRate;
      this.discountedCashFlowSum = data.discountedCashFlowSum;
      this.grossCapitalValueRounded = data.grossCapitalValueRounded;
      this.marketValueRounded = data.marketValueRounded;
      this.presentTerminalValue = data.presentTerminalValue;
      this.purchasersCosts = data.purchasersCosts;
      this.reportId = data.reportId;
      this.terminalValue = data.terminalValue;
      this.totalCashFlow = data.totalCashFlow;
      this.dcfMarketValue = data.dcfMarketValue;
      this.dcfHoldingPeriod = data.dcfHoldingPeriod;
      this.sayValueDCF = data.sayValueDCF;
    }
  }

  /**
   * Master widget's this instance
   * Instance of master HRentRollWidgetComponent
   */
  private masterThis: any;

  /**
   * Original widget data
   * Used to distribute data among widget pages
   */
  private originalData: any;

  /**
   * Calculation of MAX_ROWS_PER_PAGE
   */
  private get MAX_ROWS_PER_PAGE() {
    return this.pageNo === 0 ? 63 : 70;
  }

  /**
   * Calculation of CHARTS_HEIGHT_ROWS
   */
  private get CHARTS_HEIGHT_ROWS() {
    return this.pageNo === 0 ? 26 : 28;
  }

  /**
   * Array of page data
   */
  private widgetPages: Array<HCashFlowWidgetPageData>;

  /**
   * Page number
   */
  public pageNo = 0;

  /**
   * Should lower table be shown?
   */
  public showLowerTable = false;

  /**
   * Rows array
   */
  public rows: any[] = [];

  /**
   * Years array
   */
  public years: any[] = [];

  /**
   * Widget data: capitalisationRate
   */
  public capitalisationRate: number;

  /**
   * Widget data: cashFlowSum
   */
  public cashFlowSum: number;

  /**
   * Widget data: discountRate
   */
  public discountRate: number;

  /**
   * Widget data: discountedCashFlowSum
   */
  public discountedCashFlowSum: number;

  /**
   * Widget data: grossCapitalValueRounded
   */
  public grossCapitalValueRounded: number;

  /**
   * Widget data: marketValueRounded
   */
  public marketValueRounded: number;

  /**
   * Widget data: presentTerminalValue
   */
  public presentTerminalValue: number;

  /**
   * Widget data: purchasersCosts
   */
  public purchasersCosts: number;

  /**
   * Widget data: reportId
   */
  public reportId: number;

  /**
   * Widget data: terminalValue
   */
  public terminalValue: number;

  /**
   * Widget data: totalCashFlow
   */
  public totalCashFlow: number;

  /**
   * Widget data: dcfMarketValue
   */
  public dcfMarketValue: number;

  /**
   * Widget data: dcfHoldingPeriod
   */
  public dcfHoldingPeriod: number;

  /**
   * Widget data: sayValueDCF
   */
  public sayValueDCF: number;

  /**
   * Processes data and distributes among pages
   */
  public processData() {
    const data = this.originalData;

    let page: HCashFlowWidgetPageData = this;

    for (const row of data.rows) {
      page = page.addRow(row);
    }

    const rowsCount = page.rows.length;

    let maxRowsForChartsToFit = page.MAX_ROWS_PER_PAGE - page.CHARTS_HEIGHT_ROWS;

    // if last page has less then 
    if (rowsCount <= maxRowsForChartsToFit) {
      if (page.pageNo == 0) {
        for (let idx = rowsCount; idx < maxRowsForChartsToFit; idx++) {
          page.rows.push({ isEmpty: true, emptyPlaceholderRow: true });
        }
      }
    } else {
      page = this.createNewPage();
      maxRowsForChartsToFit = page.MAX_ROWS_PER_PAGE - page.CHARTS_HEIGHT_ROWS;
      for (let idx = 0; idx < maxRowsForChartsToFit; idx++) {
        page.rows.push({ isEmpty: true, emptyPlaceholderRow: true });
      }
    }

    //display chart on last page
    page.showLowerTable = true;
  }

  /**
   * Adds row to current page
   * @param row {any} Data row
   */
  addRow(row: any): HCashFlowWidgetPageData {
    const page = this.getPage();
    page.rows.push(row);
    return page;
  }

  /**
   * Creates new page
   */
  createNewPage() {
    const page = new HCashFlowWidgetPageData(this.masterThis, this.originalData);
    page.pageNo = this.widgetPages.length;
    this.widgetPages.push(page);
    return page;
  }

  /**
   * Gets the page
   */
  getPage(): HCashFlowWidgetPageData {
    const len = this.rows.length;

    if (len >= this.MAX_ROWS_PER_PAGE) {
      const page = this.createNewPage();
      return page;
    }

    return this;
  }



}
